import { useQuery } from "@tanstack/react-query";
import axiosInstance, { endpoints } from "../../services/axios";
import { get } from "lodash";
import { BsThreeDotsVertical } from "react-icons/bs";
import {App, Button, Dropdown, Flex, Image, MenuProps, message, Table, Typography} from "antd";

import { ISurvey } from "models";
import { useSearchParams } from "react-router-dom";
import { useBoolean } from "hooks/use-boolean";
import AddEditManagerDialog from "./add-manager-dialog";
import {DeleteOutlined, UserOutlined} from "@ant-design/icons";

interface Props {
  permissions: Record<string, boolean>;
}

const ManagersTab = ({ permissions }: Props) => {
  const { modal } = App.useApp();
  const [searchParams] = useSearchParams();
  const modalBool = useBoolean();

  const {
    data: managersData,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ["managers-list"],
    queryFn: async () => {
      axiosInstance.defaults.headers.common.Authorization = searchParams.get("token");
      return await axiosInstance.get(endpoints.manager.list);
    },
  });

  const managers: any[] = get(managersData, "data.data", []);

  const confirmDelete = (managerId: string) => () => {
    modal.confirm({
      title: "Delete manager",
      content: "Are you sure you want to delete this manager?",
      onOk: async () =>
        await axiosInstance
          .delete(endpoints.manager.delete(managerId))
          .then(() => {
            refetch();
            message.success("Manager successfully deleted!");
          })
          .catch(() => ""),

      okText: "Yes, delete",
      cancelText: "No, cancel",
    });
  };

  const columns = [
    {
      title: "№",
      dataIndex: "no",
      render: (_: any, i: any, index: number) => index + 1,
      width: 30,
    },
    {
      title: "Image",
      width: 80,
      render: (value: any) => <>{value.photo ?
          <Image className="rounded-full !w-[60px] !h-[60px] object-cover" src={value.photo} alt={value.name}/> :
          <div className="w-[50px] h-[50px] flex justify-center items-center rounded-full bg-gray-100"><UserOutlined style={{ fontSize: 32 }} /></div>}</>
    },
    {
      title: "Full name",
      dataIndex: "fio",
      key: "fio",
    },
    // {
    //   title: "Name",
    //   dataIndex: "name",
    //   key: "name",
    // },
    // {
    //   title: "Last Name",
    //   dataIndex: "lastName",
    //   key: "lastName",
    // },
    // {
    //   title: "Patron",
    //   dataIndex: "patron",
    //   key: "patron",
    // },
    {
      title: "",
      dataIndex: "actions",
      key: "id",
      align: "right" as "right",
      width: 50,

      render: (_: any, row: ISurvey) => {
        const items: MenuProps["items"] = [];

        if (permissions?.canDeleteManager) items.push({ key: "delete", label: "Delete", onClick: confirmDelete(row.id), icon: <DeleteOutlined />, danger: true });

        return (
          <Dropdown menu={{ items }} placement="bottomRight">
            <Button size="small" type="text" icon={<BsThreeDotsVertical />} />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div>
      <Flex align="center" justify="space-between" className="my-3">
        <Typography.Title className="mt-0" level={4}>
          Managers
        </Typography.Title>
        {get(permissions, "canAddManager") && (
          <Button type="primary" onClick={modalBool.onTrue}>
            + Add manager
          </Button>
        )}
      </Flex>

      <Table loading={isFetching} rowKey={"id"} pagination={false} dataSource={managers} columns={columns} />

      <AddEditManagerDialog refetch={refetch} modalBool={modalBool} />
    </div>
  );
};

export default ManagersTab;
